import React from 'react';

export function Switch({ label, checked = false, onChange, disabled = false }) {
  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? .5 : 1, fontSize: 'var(--fs-body-md)', color: 'var(--text-1)' }}>
      <span
        onClick={() => !disabled && onChange && onChange(!checked)}
        style={{
          width: 40, height: 24, borderRadius: 999, flex: 'none', position: 'relative',
          background: checked ? 'var(--brand-primary)' : 'var(--border-strong)',
          transition: 'background var(--duration-fast) var(--ease-standard)',
        }}
      >
        <span style={{
          position: 'absolute', top: 3, left: checked ? 19 : 3, width: 18, height: 18, borderRadius: '50%',
          background: '#fff', boxShadow: '0 1px 2px rgba(0,0,0,.25)', transition: 'left var(--duration-fast) var(--ease-standard)',
        }} />
      </span>
      {label}
    </label>
  );
}
